export default __webpack_public_path__ + "static/media/sliderIndicator.2a73c48c.svg";